module.exports = __webpack_public_path__ + "img/Liefervampir.d771ef44.svg";